import { render, staticRenderFns } from "./ProductContentManagementSideMenu.vue?vue&type=template&id=2d6626e9&"
import script from "./ProductContentManagementSideMenu.vue?vue&type=script&lang=js&"
export * from "./ProductContentManagementSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports